'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import ViewContainerContext from '../../containers/ViewContainerContext';
import PresentationRecord from '../../records/PresentationRecord';
import Loadable from 'UIComponents/decorators/Loadable';
import ViewToolbar from './ViewToolbar';
import ViewContent from './ViewContent';
const LoadablePreviewAlert = Loadable({
  loader: () => import(
  /* webpackChunkName: "view-secondary-content" */
  './PreviewAlert')
});
const LoadableUTMBanner = Loadable({
  loader: () => import(
  /* webpackChunkName: "view-secondary-content" */
  './UTMBanner')
});
export default class PublicView extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      pageDrawerOpen: true
    };

    this.handlePageDrawerToggle = () => {
      this.setState(({
        pageDrawerOpen
      }) => ({
        pageDrawerOpen: !pageDrawerOpen
      }));
    };

    this.renderPreviewAlert = () => {
      if (!this.context.isPreview) {
        return null;
      }

      return /*#__PURE__*/_jsx("div", {
        "data-test-id": "preview-alert",
        children: /*#__PURE__*/_jsx(LoadablePreviewAlert, {
          deckId: this.props.presentation.id
        })
      });
    };

    this.renderUTM = () => {
      if (!this.props.presentation.brandingMetadata.showSalesAd) {
        return null;
      }

      return /*#__PURE__*/_jsx(LoadableUTMBanner, {});
    };
  }

  componentDidMount() {
    const {
      isPreview
    } = this.context;
    const {
      onIdentifyViewer,
      onFinishActivity,
      presentation
    } = this.props; // const config = {
    //   appName: 'documents-public',
    //   containers: {
    //     default: {
    //       parent: document.getElementById('public-view-fire-alarm-container'),
    //     },
    //   },
    // };
    // import(
    //   /* webpackChunkName: "view-secondary-content" */ 'FireAlarmUi/js/FireAlarmApp'
    // ).then(({ default: FireAlarmApp }) => {
    //   const fireAlarm = new FireAlarmApp(window.hubspot, config);
    //   window.hubspot[FireAlarmApp.HUBSPOT_FIREALARM_KEY] = fireAlarm;
    //   fireAlarm.start();
    // });

    if (!isPreview) {
      onIdentifyViewer(presentation);

      window.onbeforeunload = () => onFinishActivity();
    }
  }

  render() {
    const {
      presentation,
      meetingLink,
      fetchDownloadLink
    } = this.props;
    const {
      pageDrawerOpen
    } = this.state;
    return /*#__PURE__*/_jsxs("div", {
      className: "public-view",
      children: [/*#__PURE__*/_jsxs("div", {
        style: {
          position: 'relative'
        },
        children: [/*#__PURE__*/_jsx("div", {
          id: "public-view-fire-alarm-container"
        }), /*#__PURE__*/_jsx(ViewToolbar, {
          presentation: presentation,
          meetingLink: meetingLink,
          fetchDownloadLink: fetchDownloadLink,
          onPageDrawerToggle: this.handlePageDrawerToggle
        })]
      }), this.renderPreviewAlert(), /*#__PURE__*/_jsx(ViewContent, {
        presentation: presentation,
        file: presentation.pdfUrl,
        pageDrawerOpen: pageDrawerOpen
      }), this.renderUTM()]
    });
  }

}
PublicView.propTypes = {
  presentation: PropTypes.instanceOf(PresentationRecord).isRequired,
  meetingLink: PropTypes.string,
  onIdentifyViewer: PropTypes.func,
  onFinishActivity: PropTypes.func,
  fetchDownloadLink: PropTypes.func.isRequired
};
PublicView.contextType = ViewContainerContext;